const _isProduction = (): boolean => {
    try {
        /* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */
        return Boolean(process !== undefined && process.env['NODE_ENV'] === 'production');
    } catch (error: unknown) {
        return true;
    }
};

export default Object.freeze({
    isProduction: _isProduction(),
});
